import { useService } from 'react-reservice';

import { copyTradeAssetService } from './service';

export const useCopyTradeProfile = () => {
  return useService(copyTradeAssetService, (context) => context.copyTradeProfile);
};

export const useCopyTradeProfileImage = () => {
  return useService(copyTradeAssetService, (context) => context.copyTradeProfileImage);
};

export const useIsLoadingCopyTradeProfile = () => {
  return useService(copyTradeAssetService, (context) => context.isLoadingCopyTradeProfile);
};

export const useCopyTradeMissedTrades = () => {
  return useService(copyTradeAssetService, (context) => context.copyTradeMissedTrades);
};

export const useIsLoadingCopyTradeMissedTrades = () => {
  return useService(copyTradeAssetService, (context) => context.isLoadingCopyTradeMissedTrades);
};

export const useIsLoadingEditCopyTradeOrder = () => {
  return useService(copyTradeAssetService, (context) => context.isLoadingEditCopyTradeOrder);
};

export const useIsLoadingCloseCopyTradeOrder = () => {
  return useService(copyTradeAssetService, (context) => context.isLoadingCloseCopyTradeOrder);
};

export const useIsLoadingGetCopyTradeOrder = () => {
  return useService(copyTradeAssetService, (context) => context.isLoadingGetCopyTradeOrder);
};

export const useCopyTradeOrder = () => {
  return useService(copyTradeAssetService, (context) => context.copyTradeOrder);
};
